import { useCallback, useEffect, useState } from 'react';
import { getInstructorById } from '../services/instructors';
import { mapInstructorDetail } from '../utils/instructorMappers';

export function useInstructorDetail(instructorId) {
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInstructor = useCallback(async () => {
    if (!instructorId) {
      setTeacher(null);
      setError('Instructor not found');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getInstructorById(instructorId);

      if (!response?.success || !response?.data) {
        setTeacher(null);
        setError(response?.message || 'Instructor not found');
        return;
      }

      setTeacher(mapInstructorDetail(response.data));
    } catch (e) {
      setTeacher(null);
      setError(e?.message || 'Failed to load instructor details');
    } finally {
      setLoading(false);
    }
  }, [instructorId]);

  useEffect(() => {
    fetchInstructor();
  }, [fetchInstructor]);

  return {
    teacher,
    loading,
    error,
    refetch: fetchInstructor,
  };
}
